export const SIDEBAR_DATA = {
    icons: [
        {
            id: 'alerts',
            display: false,
            icon: 'img/icons/alert_white.png',
            greenIcon: 'img/icons/alert_green.png',
            route:'/alerts',
            active: false,
            dynamic: true,
            label: 'Alerts'
        },
        {
            id: 'contacts',
            display: false,
            icon: 'img/icons/people_white.png',
            greenIcon: 'img/icons/people_green.png',
            route:'/contacts',
            active: false,
            label: 'Contacts'
        },
        {
            id: 'conference',
            display: false,
            icon: 'img/icons/call_conference_white.png',
            greenIcon: 'img/icons/call_conference_green.png',
            route:'/conference',
            active: false,
            label: 'Conference'
        },
        {
            id: 'reporting',
            display: false,
            icon: 'img/icons/reporting_white.png',
            greenIcon: 'img/icons/reporting_white.png',
            route:'/reporting',
            active: false,
            label: 'Reporting'
        },
        {
            id: 'admin',
            display: false,
            icon: 'img/icons/admin_white.png',
            greenIcon: 'img/icons/settings_green.png',
            route:'/admin',
            active: false,
            label: 'Admin'
        },
        {
            id: 'logout',
            display: false,
            icon: 'img/icons/logout_white.png',
            greenIcon: 'img/icons/logout_white.png',
            route:'/logout',
            active: false,
            label: 'Log Out'
        }
    ]
}